import React from 'react'

export default () => {
  return (
    <div className="loading">
      <div className="loading__spinnerWrapper">
        <div className="loading__spinner" />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/desktop/components/loading/index.js